// extracted by mini-css-extract-plugin
module.exports = {"cpAvatar":"cpAvatar_cpAvatar__XHWo5","avatarImg":"cpAvatar_avatarImg__rPwmN","evil":"cpAvatar_evil__wMtzC","angel":"cpAvatar_angel__EqloA"};